import { DataBean } from "../DataBean";


export class EmployeeContract extends DataBean {

    public async getEmployeeContracts(year: number | null, month: number | null, employeeIDList: any | null, employmentTypeList: any | null, idLnFunctionalID: number | null, idEntailment: number | null, idAppointment: number | null, state: number | null, idLnSite: number | null, regexStr: string | null, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", 
            "com.advantage.shared.Report_getEmployeeContracts_Number_Number_java.util.List_java.util.List_Number_Number_Number_Number_Number_String_Number_Number", 
            [year, month, employeeIDList, employmentTypeList, idLnFunctionalID, idEntailment, idAppointment, state, idLnSite, regexStr, page, recordsPerPage]);
    }

    public async getEmployeeContract(idAccount: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeContract_Number", [idAccount]);
    }

    public async getDocumentTemplateParsed(idDocumentTemplate: number, props: any, fileType: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentTemplateParsed_Number_java.util.Map_String", [idDocumentTemplate, props, fileType]);
    }

    public async getDocumentTemplateCatalog(processType: number, groupCode: any, isEnabled: boolean | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentTemplateCatalog_Number_String_Boolean", [processType, groupCode, isEnabled]);
    }

    public async getActiveEmployeeContractsWithoutFunctionalArea(page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getActiveEmployeeContractsWithoutFunctionalArea_Number_Number", [page, recordsPerPage]);
    }

    public async updateFunctionalAreaAndAppointmentForEmployeeContract(idContract: number, fromDate: Date, idAppointment: number | null, idLnFunctionalArea: number | null, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContract_updateFunctionalAreaAndAppointmentForEmployeeContract_Number_java.util.Date_Number_Number_Number", [idContract, fromDate, idAppointment, idLnFunctionalArea, idEmployee]);
    }

    public async updateEmployeeContract(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContract_updateEmployeeContract_employees.EmployeeContract", [{
            "DataBeanProperties": bean,
            "DataBeanName": "employees.EmployeeContract"
        }]);
    }
    public async getEmployeeContractsWithDefeatDates(defeatDays: any, employeeID: any, initDate: any, employmentTypeList: any, idLnFunctionalID: any, idEntailment: any, idAppointment: any, idLnSiteID: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getEmployeeContractsWithDefeatDates_Number_Number_java.util.Date_java.util.List_Number_Number_Number_Number_String_Number_Number", [defeatDays, employeeID, initDate, employmentTypeList, idLnFunctionalID, idEntailment, idAppointment, idLnSiteID, regexStr, page, recordsPerPage]);
    }


    public async getPayrollMnemonicCatalog(payrollMnemonic: string | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollMnemonicCatalog_String", [payrollMnemonic]);
    }

    public async getContractStateConstants(arg: string | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContractStateConstants_Number", [arg]);
    }

    public async getEmployeeContractHistoryByIDContract(idContract: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeContractHistoryByIDContract_Number", [idContract]);
    }

    public async getContractTypeConstants(arg: string | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContractTypeConstants_Number", [arg]);
    }

    public async getWelfareEntityCatalogByType(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getWelfareEntityCatalogByType_Number", [arg]);
    }

    public async getSalaryTypeConstants(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalaryTypeConstants_Number", [arg]);
    }

    public async getARPRiskCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getARPRiskCatalog_Number", [arg]);
    }

    public async getContributorTypeCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContributorTypeCatalog_Number", [arg]);
    }

    public async getContributorSubtypeCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getContributorSubtypeCatalog_Number", [arg]);
    }

    public async getEmployeeContractTypeCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeContractTypeCatalog_Number", [arg]);
    }

    public async getEmploymentTypeCatalog(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmploymentTypeCatalog_Number", [arg]);
    }

    public async getEmployeeLiquidateList(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmployeeLiquidateList_Number", [arg]);
    }

    public async exportEmployeeContractsTemplateXlsxFile(arg: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportEmployeeContractsTemplateXlsxFile_Number", [arg]);
    }

    public async importEmployeeContracts(filename: string, directory: string, dataStore: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importEmployeeContracts_String_String_String", [filename, directory, dataStore]);
    }

    public async migrateEmployeeLiquidate(idEmployeeLiquidate: number, idPayrollType: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_migrateEmployeeLiquidate_Number_Number",
            [idEmployeeLiquidate, idPayrollType]);
    }

    public async getPayrollLiquidateProfileEditor(arg: null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.bean.dev.RemoteAbstractAction_getPayrollLiquidateProfileEditor_Number", [arg]);
    }


    public async setFunctionalAreaToEmployeeContract(idContract: any, fromDate: any, idLnFunctionalArea: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContractHistory_setFunctionalAreaToEmployeeContract_Number_java.util.Date_Number_Number", [idContract, fromDate, idLnFunctionalArea, idEmployee]);
    }

    public async getActiveEmployeeContract(idAccount: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getActiveEmployeeContract_Number", [idAccount]);
    }

    public async getVacationsPeriodForEmployeeContract(idContract: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getVacationsPeriodForEmployeeContract_Number", [idContract]);
    }

    public async setAppointmentToEmployeeContract(idContract: number, idAppointment: number, date: any, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeContractHistory_setAppointmentToEmployeeContract_Number_Number_java.util.Date_Number", [idContract, idAppointment, date, idEmployee]);
    }

    public async removeEmployeContract(idEmployee: number, idEmployeeContract: number): Promise<any> {
        return this.getCustomService("CacheOptions", "Boolean_removeEmployeContract_Number_Number", [idEmployee, idEmployeeContract]);
    }
}